import styled from 'styled-components';

export const Root = styled.div`
  background: #f0f0f0;
  height: 100%;
  overflow: hidden;
`;
